// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".drop-modal{display:flex;justify-content:center;flex-direction:column;align-items:center;visibility:hidden;position:fixed;left:0;top:0;z-index:10;width:100vw;height:100vh;background:hsla(0,0%,100%,.9);color:#2254f4;opacity:0;transition:opacity .3s,visibility .3s}.drop-modal p{font-size:48px;font-weight:700;line-height:67px}.drop-modal span{font-size:18px;line-height:25px}.drop-modal--show{visibility:visible;opacity:1}", ""]);
// Exports
module.exports = exports;
